module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "15px",
      "background-color": "#eee"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin": "18px 0 10px 10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('b', {
    staticStyle: {
      "font-size": "16px",
      "color": "#5c5c5c",
      "font-weight": "normal"
    }
  }, [_vm._v("热门推荐")])]), _vm._v(" "), _vm._l((_vm.hotProducts.slice(0, 4)), function(item, index) {
    return _c('el-col', {
      attrs: {
        "span": 6,
        "offset": 0
      }
    }, [_c('lh-product', {
      attrs: {
        "title": item.title,
        "summary": item.summary,
        "img": _vm._f("cdn-filter")(item.img),
        "price": item.price,
        "serialId": _vm.getRegion.code + item.serialId
      }
    })], 1)
  })], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8fdbf9ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HotProducts.vue
// module id = 1052
// module chunks = 40